import { DataProtectionSettingsProvider } from "@/pages/settings/data-protection/index/components/DataProtectionSettingsProvider.tsx";
import { useDataProtectionSettings } from "@/queries/use-data-protection.query.ts";
import analyticsService, {
  analyticEvents,
  analyticProperties,
} from "@/services/analytics-service.ts";
import { Skeleton, Stack } from "@skailer-com/uikit";
import { useEffectOnce } from "react-use";

export function DataProtectionTabSettings() {
  const { data, isLoading } = useDataProtectionSettings();

  useEffectOnce(() => {
    analyticsService.trackEvent(analyticEvents.dataProtection.viewed, {
      [analyticProperties.tab]: "Settings",
    });
  });

  return (
    <Stack className={"my-6"} gap={"lg"}>
      {isLoading && <Skeleton className={"h-8"} />}
      {data &&
        data.map((provider) => (
          <DataProtectionSettingsProvider
            provider={provider}
            key={`provider_settings_${provider.data_protection_type}`}
          />
        ))}
    </Stack>
  );
}
